import { useState } from "react";
import { Heart, MessageCircle, FileText, Menu, X } from "lucide-react";
import iconLogo from "../assets/iconLogo.png";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header top */}
        <div className="flex justify-between items-center py-4">
          
          {/* Logo + Text */}
          <div className="flex items-center space-x-3">
            <img 
              src={iconLogo} 
              width={50}
              className="rounded-xl"
            />
            <div>
              <h1 className="text-lg sm:text-xl font-bold text-gray-900">Ser Efimed S.A.</h1>
              <p className="text-xs sm:text-sm text-gray-600">Servicio y Eficiencia Médica</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <a href="#inicio" className="text-gray-700 hover:text-blue-600 font-medium">Inicio</a>
            <a href="#productos" className="text-gray-700 hover:text-blue-600 font-medium">Productos</a>
            <a href="#servicios" className="text-gray-700 hover:text-blue-600 font-medium">Servicios</a>
            <a href="#contacto" className="text-gray-700 hover:text-blue-600 font-medium">Contacto</a>
          </nav>

          {/* Desktop Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href="https://wa.me/50683354555"
              target="_blank"
              className="bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-lg flex items-center space-x-2 shadow-md text-sm"
            >
              <MessageCircle className="w-5 h-5" />
              <span>WhatsApp</span>
            </a>

            <a 
              href="#cotizacion"
              className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg flex items-center space-x-2 shadow-md text-sm"
            >
              <FileText className="w-5 h-5" />
              <span>Cotización</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden"
            onClick={() => setOpen(!open)}
          >
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {open && (
          <div className="md:hidden pb-4 space-y-4 animate-fadeIn">
            <nav className="flex flex-col space-y-3">
              <a href="#inicio" className="text-gray-700 hover:text-blue-600 font-medium">Inicio</a>
              <a href="#productos" className="text-gray-700 hover:text-blue-600 font-medium">Productos</a>
              <a href="#servicios" className="text-gray-700 hover:text-blue-600 font-medium">Servicios</a>
              <a href="#contacto" className="text-gray-700 hover:text-blue-600 font-medium">Contacto</a>
            </nav>

            <div className="flex flex-col space-y-3">
              <a 
                href="https://wa.me/50683354555"
                target="_blank"
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg flex items-center justify-center space-x-2 shadow-md"
              >
                <MessageCircle className="w-5 h-5" />
                <span>WhatsApp</span>
              </a>

              <a 
                href="#cotizacion"
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center justify-center space-x-2 shadow-md"
              >
                <FileText className="w-5 h-5" />
                <span>Cotización</span>
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
